import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "normalize.css";
import { Provider } from "react-redux";
import store from '../src/store/store.js';
import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API || "http://localhost:4001";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);
reportWebVitals();
